import { MiddlewareRegistry } from 'store';
import moment from 'moment';
import { setToken } from 'libs';
import { LOGIN, LOGOUT, CLEAR } from '../types';
import { serviceInstance } from 'libs';

const clearStorage = (next) => {
  window.localStorage.removeItem('collectionsAccessData');
  window.localStorage.removeItem('collectionsUser');
  setToken(null);
  next({ type: CLEAR });
};

export const localStorageMiddleware = MiddlewareRegistry.register(
  (store) => (next) => (action) => {
    let localAccessData = localStorage.getItem('collectionsAccessData');
    let parsedCollectionAccessData = JSON.parse(localAccessData);
    let loginTime = parsedCollectionAccessData?.time;

    let login = moment(loginTime);
    let logout = moment();

    let diff = logout.diff(login, 'minute');

    //checker for setting local storage info

    if (action.type === LOGIN) {
      if (!action.error) {
        const token = action.accessData.token;
        window.localStorage.setItem(
          'collectionsAccessData',
          JSON.stringify(action.accessData)
        );
        window.localStorage.setItem(
          'collectionsUser',
          JSON.stringify(action.user)
        );
        setToken(token);
      }
      next(action);
    } else if (action.type === LOGOUT) {
      clearStorage(next);
      return;
    }

    //checker for auto logout

    if (diff > 25) {
      clearStorage(next);
      return;
    } else if (action?.type !== LOGIN && diff < 25) {
      const updatedCollectionAccessData = JSON.stringify({
        ...parsedCollectionAccessData,
        time: new Date(),
      });
      window.localStorage.setItem(
        'collectionsAccessData',
        updatedCollectionAccessData
      );

      next(action);
    }

    //checker for authorized

    serviceInstance.interceptors.response.use(
      (data) => {
        return data;
      },
      (error) => {
        if ([401, 403].includes(error?.response?.status)) {
          clearStorage(next);
        }
        return Promise.reject(error);
      }
    );
  }
);
